import React, { useEffect, Suspense, lazy, createElement } from 'react';
import { DeferredSection } from './components/DeferredSection';
import { Hero } from './components/Hero';
import { Pricing } from './components/Pricing';
import { PurchasePopup } from './components/Shared';
const Problem = lazy(() => import('./components/Problem').then(m => ({
  default: m.Problem
})));
const Product = lazy(() => import('./components/Product').then(m => ({
  default: m.Product
})));
const Bonuses = lazy(() => import('./components/Bonuses').then(m => ({
  default: m.Bonuses
})));
const Social = lazy(() => import('./components/Social').then(m => ({
  default: m.Social
})));
const FAQ = lazy(() => import('./components/FAQ').then(m => ({
  default: m.FAQ
})));
const Footer = lazy(() => import('./components/Footer').then(m => ({
  default: m.Footer
})));
const FB_PIXEL_ID = '1545009850674181';
declare global {
  interface Window {
    fbq?: ((...args: unknown[]) => void) & {
      callMethod?: (...args: unknown[]) => void;
      queue?: unknown[];
      loaded?: boolean;
      version?: string;
      push?: unknown;
    };
    _fbq?: unknown;
  }
}
function EmptyFallback() {
  return null;
}
export function App() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    try {
      if (window.self !== window.top) return;
    } catch {
      return;
    }
    let pixelStarted = false;
    let fallbackTimer: number | undefined;
    const loadPixel = () => {
      if (pixelStarted) return;
      pixelStarted = true;
      if (fallbackTimer) window.clearTimeout(fallbackTimer);
      try {
        if (window.fbq) {
          window.fbq('track', 'PageView');
          return;
        }
        ;
        (function (f: any, b: Document, e: string, v: string) {
          let n: any;
          if (f.fbq) return;
          n = f.fbq = function () {
            n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
          };
          if (!f._fbq) f._fbq = n;
          n.push = n;
          n.loaded = true;
          n.version = '2.0';
          n.queue = [];
          const script = b.createElement(e);
          script.async = true;
          script.src = v;
          script.onerror = () => undefined;
          b.head.appendChild(script);
        })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
        window.fbq?.('init', FB_PIXEL_ID);
        window.fbq?.('track', 'PageView');
      } catch {
        // Tracking must never block or break the landing page.
      }
    };
    fallbackTimer = window.setTimeout(loadPixel, 5000);
    const requestIdle = (window as Window & {
      requestIdleCallback?: (callback: () => void) => number;
    }).requestIdleCallback;
    const idleId = requestIdle?.(loadPixel);
    return () => {
      if (fallbackTimer) window.clearTimeout(fallbackTimer);
      if (idleId !== undefined && 'cancelIdleCallback' in window) {
        ;
        (window as Window & {
          cancelIdleCallback: (id: number) => void;
        }).cancelIdleCallback(idleId);
      }
    };
  }, []);
  return <div className="min-h-screen bg-brand-cream font-sans text-brand-charcoal selection:bg-brand-terracotta/30" data-id="element-0" data-mp="yg3l4w0rjpqw">
      <Hero data-id="element-1" data-mp="13fq0bb05jg2c" />

      <DeferredSection minHeight={420} triggerEvent="pilates360:prepare-checkout" data-id="element-2" data-mp="13fgabnf3x8wn">
        <Suspense fallback={<EmptyFallback data-id="element-4" data-mp="1r267obgigfax" />} data-id="element-3" data-mp="1r4seg8vkuqs3">
          <Problem data-id="element-5" data-mp="1w33oajlvh1ab" />
        </Suspense>
      </DeferredSection>
      <DeferredSection minHeight={560} triggerEvent="pilates360:prepare-checkout" data-id="element-6" data-mp="1w2kfpti43p8y">
        <Suspense fallback={<EmptyFallback data-id="element-8" data-mp="1m561m0jnvcjt" />} data-id="element-7" data-mp="1i5nh35vr53hi">
          <Product data-id="element-9" data-mp="1m4ehblvil18u" />
        </Suspense>
      </DeferredSection>
      <DeferredSection minHeight={520} triggerEvent="pilates360:prepare-checkout" data-id="element-10" data-mp="1m70m5dr0t2nd">
        <Suspense fallback={<EmptyFallback data-id="element-12" data-mp="aqistmipzg4y" />} data-id="element-11" data-mp="aq0yivfmbbzo">
          <Bonuses data-id="element-13" data-mp="aqsi17vxxj9l" />
        </Suspense>
      </DeferredSection>
      <Pricing data-id="element-14" data-mp="qxnljkj88cuj" />
      <DeferredSection minHeight={440} data-id="element-15" data-mp="qxfazzaktjmi">
        <Suspense fallback={<EmptyFallback data-id="element-17" data-mp="m6fbqndzipgu" />} data-id="element-16" data-mp="qz8ghb9gdxsx">
          <Social data-id="element-18" data-mp="m65k6vdaka91" />
        </Suspense>
      </DeferredSection>
      <DeferredSection minHeight={420} data-id="element-19" data-mp="m4m3x4rmxz79">
        <Suspense fallback={<EmptyFallback data-id="element-21" data-mp="h843gh3c8n0q" />} data-id="element-20" data-mp="h6kmeo9uy7xw">
          <FAQ data-id="element-22" data-mp="h59j0pkbr27b" />
        </Suspense>
      </DeferredSection>
      <DeferredSection minHeight={240} data-id="element-23" data-mp="c9ao0j4hqlxx">
        <Suspense fallback={<EmptyFallback data-id="element-25" data-mp="19vztx42bdip2" />} data-id="element-24" data-mp="c66ct1slypxr">
          <Footer data-id="element-26" data-mp="19w9pd764oi25" />
        </Suspense>
      </DeferredSection>

      <PurchasePopup data-id="element-27" data-mp="19tndivc7fge4" />
    </div>;
}